"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconTooltip = require("./IconTooltip");

var _IconTooltip2 = _interopRequireDefault(_IconTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["question"],

  data: function data() {
    return {
      show: false
    };
  },


  components: {
    IconTooltip: _IconTooltip2.default
  }
}; //
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/general/Explanation.vue
// module id = NS5O
// module chunks = 0 1